<template>
  <div
    :class="{
      'hekate-progress-bar d-none': true,
    }"
  >
    <div class="content-wrapper">
      <div
        :class="{
          progress: true,
        }"
        role="progressbar"
        aria-label="Success example"
        aria-valuenow="10"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div
          :class="{
            'progress-bar bg-success': true,
          }"
          style="width: 10%"
        ></div>
      </div>
    </div>
  </div>
</template>
